import { React, useEffect, useState } from 'react'
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import FetchOwnUser from '../components/FetchOwnUser';
import Menulist from '../components/Menulist';
import FetchOwnSections from '../components/FetchOwnSections';
import FetchUserpopup from '../components/FetchUserpopup';
import FetchOwnUserPopup from '../components/FetchOwnUserPopup';
import FetchOwnSectionsPopup from '../components/FetchOwnSectionsPopup';
import FetchSectionspopup from '../components/FetchSectionspopup';



//import Google from './components/Google';
function Mypage() {
  document.body.classList.remove('personalize-end');
  document.body.classList.remove('personalize');
  document.body.classList.remove('path-journey');
  document.body.classList.remove('path-personalize');
  
  const [userslength, setuserslength] = useState();
  const [sectionslength, setsectionslength] = useState();
  const [removedPageSecions, setPageSections] = useState([]);
  const [removedPageUsers, setPageUsers] = useState([]);
  const handleChecknow = (evnt) => {
    if (evnt === 'selectauthorpopup') {
      window.location.reload(false);
    }
    if (evnt === 'successssecondfacebook') {
      var domainurl = window.location.origin;
      window.location.href = domainurl + '/#/personalize';
    }

  }

  const handleCheckedPopup = (tid) => {
    
     removedPageSecions.push(tid);
     
    

  }

  const handleUserCheckedPopup = (tid) => {
   
     removedPageUsers.push(tid);

  }


  const location = useLocation();
  const navigate = useNavigate();
  const handleCheckChangeuser = (evnt) => {
    if (evnt != '') {
      setuserslength(evnt);
      // navigate('/personalize-sections');
    }
    // navigate('/personalize-sections');
  }

  const handleChecknowSections = (evnt) => {
    if (evnt != '') {
      setsectionslength(evnt);
      // navigate('/personalize-sections');
    }
    // navigate('/personalize-sections');
  }

  var element = document.getElementById("header-react");
  if(element){
  element.classList.remove("hide");
  }

  if (!localStorage.getItem('user-info')) {

    return <Navigate to="/" />

  } else {
    return (
      <div className="grid-container">

        <div className="grid-x grid-margin-x my-page">

          <div className="cell large-3">
            <Menulist samircallback={location.pathname} />
          </div>
          <div className="cell auto">
            <div className="mypage-area">

              <div className="tabs-content" data-tabs-content="profile-tabs">
                <div className="tabs-panel is-active" id="mypage">
                  <div className="manage-block">
                    <div className="topper-title">
                      <h3>كتابي المفضلون</h3>
                    </div>
                    <div className="my-authors">
                          <FetchOwnUser  />
                    </div>
                  
                  </div>
                  <div className="manage-block">
                    <div className="topper-title">
                      <h3>مواضيعي المفضلة</h3>
                    </div>
               
                    
                        <FetchOwnSections fetchpopupcallback={handleCheckedPopup} pSections={removedPageSecions} fetchownsectioncallback={handleChecknowSections} />
                       
                     



                   
                   
                  
                  </div>
                </div>


              </div>


            </div>
          </div>
        </div>
      </div>
    );

  }
}

export default Mypage;

